module.exports = __webpack_public_path__ + "static/media/member_favorite_02.1b64d98b.jpg";